<template>
  <b-container fluid>
    <b-card no-body>
      <b-navbar type="dark" variant="dark">
        <b-nav-form>
          <b-navbar-brand class="bootstrapTable">Options:</b-navbar-brand>
          <b-form-select v-model="currentYear" :options="yearsDropDown" />
          <b-form-select v-model="cycleType" :options="cycleTypeOptions" class="ml-2" @change="getCurrentPayPeriod" />
          <b-form-select v-if="cycleType == 'Pay Period'"   v-model="currentView" :options="previousPayrolls" />
          <b-form-select v-if="cycleType == 'Work Cycle'"  v-model="currentView" :options="previousWorkCycles" />
          <b-form-select v-if="cycleType == 'Work Week'"   v-model="currentView" :options="previousWorkWeeks" />
          <b-form-select v-if="cycleType == 'Kelly Cycle'" v-model="currentView" :options="previousKellyCycles" />
          <b-form-input v-if="cycleType == 'Select Range'" type="date" v-model="selectStart" />
          <b-form-input v-if="cycleType == 'Select Range'" type="date" v-model="selectEnd" />
          <b-btn v-if="cycleType == 'Select Range'" variant="info" @click="runRangeDate">Run</b-btn>
        </b-nav-form>
        <b-btn class="ml-2" variant="primary" @click="showFilter = !showFilter">Filter</b-btn>
      </b-navbar>

      <b-row>
        <b-col cols="3" v-if="showFilter" align="left">
          <b-form-group label="Select Export Codes to Hide" class="mt-2">
            <b-form-checkbox-group
              v-model="selectedFilter"
              :options="filterProfileModOptions"
              name="filter-mod-options"
              stacked
            />
          </b-form-group>
          <b-form-checkbox v-model="selectAllBoo" @change="selectAllEventMods($event, filterProfileModOptions)">
            Hide All Export Codes?
          </b-form-checkbox>
          <b-form-checkbox v-model="hideUsersWithNone">Hide Users w/ No Mods?</b-form-checkbox>

          <b-form-group label="Filter by Shift" class="mt-2">
            <b-form-checkbox-group
              v-model="selectedShift"
              :options="filterProfileShiftOptions"
              name="filter-shift-options"
              stacked
            />
          </b-form-group>
        </b-col>

        <b-col>
          <b-container v-if="currentView">
            <h6 v-if="cycleType == 'Select Range'" class="text-danger">
              Be Advised: if your date range for "Select Range" is extensive, there will be a delay as the data is loaded.
            </h6>
            <b-card v-if="siteconfig.deptUrlSub != 'gfr'"
              v-for="user in rosterProfilesFilterdByPeriodFilter"
              :key="user.userid"
              :title="user.lastName + ', ' + user.firstName + ' (' + user.employeeId + ')'"
            >
              <b-table
                :items="user.shifts"
                :fields="['payrollModDatetime', 'payrollModExport', 'payrollModCode', 'payrollModType', 'payrollModHours']"
              >
                <template slot="payrollModDatetime" slot-scope="data">
                  {{ getDateTime(data.item.payrollModDatetime) }}
                </template>
              </b-table>
            </b-card>
          <b-card v-if="siteconfig.deptUrlSub == 'gfr'"
    v-for="user in rosterProfilesFilterdByPeriodFilter"
    :key="user.userid"
    class="mb-2"
    :header="user.lastName + ', ' + user.firstName + ' (' + user.employeeId + ')'"
    header-bg-variant="dark"
    header-text-variant="white"
  >
    <b-table
      :items="buildFlsaSummaryRows(user)"
      :fields="flsaSummaryFields"
      small
      hover
      @row-clicked="row => $set(row, '_showDetails', !row._showDetails)"
    >
      <!-- Total hours badge -->
      <template #cell(hours)="{ item }">
        <b-badge :variant="item.hours > 0 ? 'primary' : 'secondary'">
          {{ item.hours }}
        </b-badge>
      </template>
 
      <!-- Expand toggle -->
      <template #cell(details)="{ item }">
        <b-btn
          v-if="item.shifts.length > 0"
          size="sm"
          variant="outline-secondary"
          @click.stop="$set(item, '_showDetails', !item._showDetails)"
        >
          {{ item._showDetails ? '▲ Hide' : '▼ Show' }}
        </b-btn>
        <span v-else class="text-muted">—</span>
      </template>
 
      <!-- Row details — shift mod table -->
      <template #row-details="{ item }">
        <b-table
          :items="item.shifts"
          :fields="flsaDetailFields"
          small
          bordered
          class="mb-0 mt-1"
        >
          <template #cell(payrollModDatetime)="{ item: shift }">
            {{ getDateTime(shift.payrollModDatetime) }}
          </template>
          <template #cell(payrollModHours)="{ item: shift }">
            {{ Number.parseFloat(shift.payrollModHours || 0) }}
          </template>
        </b-table>
      </template>
    </b-table>
          </b-card>
          </b-container>
        </b-col>
      </b-row>
    </b-card>
  </b-container>
</template>

<script>
import { bus } from '../../../main'
import { mapState } from 'vuex'
import axios from 'axios'
import Papa from 'papaparse'
import moment from 'moment'
import multiselect from 'vue-multiselect'
import JsonExcel from 'vue-json-excel'
import Blob from 'blob'
import customJs from '../../../../customjs.js'


export default {
  name: 'flsa-tracking',

  components: {
    multiselect,
    'download-excel': JsonExcel,
  },

  props: [
    'payrollAccuralData',
    'payrollBanksData',
    'rosterProfiles',
    'rosterData',
    'payrollCodesData',
  ],

  data() {
    return {
      currentPage: 0,
      searchData: '',
      payrollBankRecoDate: '',
      currentView: null,
      showFilter: false,
      hideUsersWithNone: false,
      selectAllBoo: false,
      cycleType: 'Work Cycle',
      currentYear: '',
      selectedFilter: [],
      selectedShift: [],
      payrollRecoMods: [],
      payrollReports: [],
      viewReports: [],
      modfields: [
        { key: 'payrollModDatetime', label: 'Date' },
        { key: 'payrollModHours',    label: 'Hours' },
      ],
      flsaSummaryFields: [
        { key: 'bucket', label: 'Category',    thStyle: 'width: 160px' },
        { key: 'hours',  label: 'Total Hours', thStyle: 'width: 120px' },
        { key: 'details', label: '' },
      ],
      flsaDetailFields: [
        { key: 'payrollModDatetime', label: 'Date/Time' },
        { key: 'payrollModExport',   label: 'Export Code' },
        { key: 'payrollModCode',     label: 'Code' },
        { key: 'payrollModType',     label: 'Type' },
        { key: 'payrollModHours',    label: 'Hours' },
      ],
      selectStart: '',
      selectEnd: '',
      disableGenerateReport: true,
      createVacancy: [
        'scheduled leave',
        'unscheduled leave',
        'modified leave',
        'unpaid leave',
      ],
    }
  },

  created() {
    this.getCurrentPayPeriod()
    this.selectStart = moment().startOf('month').subtract(3, 'months').format('YYYY-MM-DD')
    this.selectEnd   = moment().startOf('month').format('YYYY-MM-DD')
  },

  mounted() {},

  computed: {
    ...mapState([
      'getSessionData',
      'apparatusData',
      'stationsData',
      'deptContactData',
      'fullDeptContactData',
      'userData',
      'siteconfig',
    ]),

    cycleTypeOptions() {
      const array = ['Pay Period', 'Work Cycle', 'Work Week']
      if (this.siteconfig.payroll.kellyCycleDate) {
        array.push('Kelly Cycle')
      }
      array.push('Select Range')
      return array
    },
    kellyDayObject() {
      if (!this.siteconfig.payroll.kellyDayPattern) return null

      const shifts       = this.siteconfig.payroll.shifts
      const kellyPattern = this.siteconfig.payroll.kellyDayPattern
      const build        = []
      const kellyArray   = []

      for (const k in kellyPattern) {
        for (const s in shifts) {
          build.push({ shift: shifts[s].shift, kelly: kellyPattern.indexOf(kellyPattern[k]) })
        }
      }

      // Walk back to the nearest cycle boundary
      let startDate = moment(this.currentView.start, 'YYYY-MM-DD').clone()
      let subDays = 0
      while (true) {
        const days     = moment(startDate).diff(this.siteconfig.payroll.cycleStartDate, 'days')
        const mathhold = days / 21
        if (mathhold == Math.floor(mathhold)) break
        startDate = startDate.subtract(1, 'day')
        subDays++
      }

      let start  = moment(this.currentView.start, 'YYYY-MM-DD').clone().subtract(subDays, 'days')
      let arrayI = 0
      while (true) {
        let obj = _.cloneDeep(build[arrayI])
        if (!obj) {
          arrayI = 0
          obj    = build[arrayI]
        }
        obj['date'] = start.clone().format('YYYY-MM-DD')
        kellyArray.push(obj)
        if (moment(start).isSameOrAfter(moment(this.currentView.end))) break
        start = start.clone().add(1, 'day')
        arrayI++
      }

      return kellyArray
    },

    previousPayrolls() {
      if (!this.currentView || !this.currentYear) return []
      const payroll       = this.siteconfig.payroll
      const today         = moment().format('YYYY-MM-DD')
      const presetVarDate = moment(payroll.payrollCycleDate, 'YYYY-MM-DD')
      const array         = []

      if (payroll.payCycleType == 'biweekly') {
        const dateDiffCal = moment(today).diff(presetVarDate, 'days')
        const end         = Math.floor(dateDiffCal / 14)
        const endDate     = moment(presetVarDate).add(end * 2, 'weeks').format('YYYY-MM-DD')
        const startDate   = moment(endDate, 'YYYY-MM-DD').subtract(14, 'days').format('YYYY-MM-DD')
        array.push({ start: moment(startDate).add(14, 'days').format('YYYY-MM-DD'), end: moment(endDate).add(14, 'days').format('YYYY-MM-DD') })
        array.push({ start: startDate, end: endDate })
        for (let i = 1; i < end; i++) {
          array.push({
            start: moment(startDate).subtract(14 * i, 'days').format('YYYY-MM-DD'),
            end:   moment(endDate).subtract(14 * i, 'days').format('YYYY-MM-DD'),
          })
        }
      } else if (payroll.payCycleType == 'weekly') {
        const dateDiffCal = moment(today).diff(presetVarDate, 'days')
        const end         = Math.floor(dateDiffCal / 7)
        const endDate     = moment(presetVarDate).add(end, 'weeks').format('YYYY-MM-DD')
        const startDate   = moment(endDate, 'YYYY-MM-DD').subtract(7, 'days').format('YYYY-MM-DD')
        array.push({ start: moment(startDate).add(7, 'days').format('YYYY-MM-DD'), end: moment(endDate).add(7, 'days').format('YYYY-MM-DD') })
        array.push({ start: startDate, end: endDate })
        for (let i = 1; i < end; i++) {
          array.push({
            start: moment(startDate).subtract(7 * i, 'days').format('YYYY-MM-DD'),
            end:   moment(endDate).subtract(7 * i, 'days').format('YYYY-MM-DD'),
          })
        }
      }

      return this._buildDropdownItems(array)
    },

    previousWorkWeeks() {
      if (!this.currentView || !this.currentYear) return []
      const payroll       = this.siteconfig.payroll
      const today         = moment().format('YYYY-MM-DD')
      const presetVarDate = moment(payroll.payrollCycleDate, 'YYYY-MM-DD')
      const dateDiffCal   = moment(today).diff(presetVarDate, 'days')
      const end           = Math.floor(dateDiffCal / 7)
      const endDate       = moment(presetVarDate).add(end, 'weeks').format('YYYY-MM-DD')
      const startDate     = moment(endDate, 'YYYY-MM-DD').subtract(7, 'days').format('YYYY-MM-DD')
      const array         = [
        { start: moment(startDate).add(7, 'days').format('YYYY-MM-DD'), end: moment(endDate).add(7, 'days').format('YYYY-MM-DD') },
        { start: startDate, end: endDate },
      ]
      for (let i = 1; i < end; i++) {
        array.push({
          start: moment(startDate).subtract(7 * i, 'days').format('YYYY-MM-DD'),
          end:   moment(endDate).subtract(7 * i, 'days').format('YYYY-MM-DD'),
        })
      }
      return this._buildDropdownItems(array)
    },

    previousKellyCycles() {
      if (!this.currentView || !this.currentYear) return []
      const payroll       = this.siteconfig.payroll
      const today         = moment().format('YYYY-MM-DD')
      const presetVarDate = moment(payroll.kellyCycleDate, 'YYYY-MM-DD').subtract(1, 'day')
      const dateDiffCal   = moment(today).diff(presetVarDate, 'days')
      const end           = Math.floor(dateDiffCal / payroll.keyllyCycle)
      let   endDate       = moment(presetVarDate).add(end * payroll.keyllyCycle, 'days').format('YYYY-MM-DD')
      const startDate     = moment(endDate, 'YYYY-MM-DD').subtract(payroll.keyllyCycle - 1, 'days').format('YYYY-MM-DD')
      endDate             = moment(endDate, 'YYYY-MM-DD').add(1, 'd').format('YYYY-MM-DD')
      const array         = [
        { start: moment(startDate).add(payroll.keyllyCycle, 'days').format('YYYY-MM-DD'), end: moment(endDate).add(payroll.keyllyCycle, 'days').format('YYYY-MM-DD') },
        { start: startDate, end: endDate },
      ]
      for (let i = 1; i < end; i++) {
        array.push({
          start: moment(startDate).subtract(payroll.keyllyCycle * i, 'days').format('YYYY-MM-DD'),
          end:   moment(endDate).subtract(payroll.keyllyCycle * i, 'days').format('YYYY-MM-DD'),
        })
      }
      return this._buildDropdownItems(array)
    },

    previousWorkCycles() {
      if (!this.currentView || !this.currentYear) return []
      const payroll       = this.siteconfig.payroll
      const today         = moment().format('YYYY-MM-DD')
      const presetVarDate = moment(payroll.cycleStartDate, 'YYYY-MM-DD').subtract(1, 'day')
      const dateDiffCal   = moment(today).diff(presetVarDate, 'days')
      const end           = Math.floor(dateDiffCal / payroll.cycle)
      let   endDate       = moment(presetVarDate).add(end * payroll.cycle, 'days').format('YYYY-MM-DD')
      const startDate     = moment(endDate, 'YYYY-MM-DD').subtract(payroll.cycle - 1, 'days').format('YYYY-MM-DD')
      if (payroll.workCycleMainExport || this.siteconfig.deptUrlSub == 'lbkfr' || this.siteconfig.deptUrlSub == 'gfr') {
        endDate = moment(endDate, 'YYYY-MM-DD').add(1, 'day').format('YYYY-MM-DD')
      }
      const array = [
        { start: moment(startDate).add(payroll.cycle, 'days').format('YYYY-MM-DD'), end: moment(endDate).add(payroll.cycle, 'days').format('YYYY-MM-DD') },
        { start: startDate, end: endDate },
      ]
      for (let i = 1; i < end; i++) {
        array.push({
          start: moment(startDate).subtract(payroll.cycle * i, 'days').format('YYYY-MM-DD'),
          end:   moment(endDate).subtract(payroll.cycle * i, 'days').format('YYYY-MM-DD'),
        })
      }
      return this._buildDropdownItems(array)
    },

    yearsDropDown() {
      const payroll       = this.siteconfig.payroll
      const today         = moment().format('YYYY')
      const presetVarDate = moment(payroll.payrollCycleDate, 'YYYY-MM-DD').format('YYYY')
      const diff          = moment(today).diff(presetVarDate, 'years')
      const years         = []
      for (let i = 0; i < diff; i++) {
        const y = Number.parseInt(presetVarDate) + i
        if (y < Number.parseInt(today)) years.push(y)
      }
      years.push(Number.parseInt(today))
      this.currentYear = Number.parseInt(today)
      return _.orderBy(years.map(y => ({ value: y.toString(), text: y })), ['text'], ['desc'])
    },

    filterProfileShiftOptions() {
      const array = _.cloneDeep(this.rosterProfilesFilterdByPeriod)
      return _.sortBy([...new Set(array.map(item => item.shiftAssignment))])
    },

    filterProfileModOptions() {
      const array  = _.cloneDeep(this.rosterProfilesFilterdByPeriod)
      const merged = [].concat.apply([], array.map(item => item.shifts))
      return _.sortBy([...new Set(merged.map(p => p.payrollModCode))])
    },
    rosterProfilesFilterdByPeriodFilter() {
      let array = _.cloneDeep(this.rosterProfilesFilterdByPeriod)
    
      if (this.selectedShift && this.selectedShift.length > 0) {
        array = array.filter(p => this.selectedShift.indexOf(p.shiftAssignment) >= 0)
      }
    
      if (this.selectedFilter && this.selectedFilter.length > 0) {
        const filter = []
        for (const p in array) {
          const obj  = array[p]
          obj.shifts = obj.shifts.filter(x => this.selectedFilter.indexOf(x.payrollModCode) < 0)
          if (!this.hideUsersWithNone || obj.shifts.length > 0) {
            filter.push(obj)
          }
        }
        array = filter
      }
    
      // GFR: split each user into flsa / nonFlsa / other buckets
      if (this.siteconfig.deptUrlSub == 'gfr') {
        var customarray = customJs.custom_flsa_gfr(array)
        console.log(customarray)
        return customarray
      }

      return array
    },
    rosterProfilesFilterdByPeriod() {
      const array  = _.cloneDeep(this.rosterProfiles)
      const rosters = array.filter(p => {
        const start = moment(p.rosterAssignmentStart).isBefore(this.currentView.end)
        const end   = p.rosterAssignmentEnd
          ? moment(p.rosterAssignmentEnd).isAfter(this.currentView.start)
          : p.rosterAssignmentEnd == null
        return start && end
      })

      const users = [...new Set(rosters.map(p => p.userId))]
      let hold = users.map(id => {
        const contact    = this.deptContactData.find(p => p.id == id) || this.fullDeptContactData.find(p => p.id == id)
        if (!contact) return null
        contact['userid'] = id
        const rosterFil   = rosters.filter(p => p.userId == id)
        contact['shifts'] = this.userProfileBuildShifts(rosterFil)
        return contact
      }).filter(Boolean)

      const mods = hold.map(item => {
        const paymods = this.payrollRecoMods.filter(p =>
          p.payrollModTargetUserId == item.id || p.payrollModExchangeUserId == item.id
        )
        item.shifts = this.sortModifications(item.shifts, paymods, item.userid, item.employeeId)
        return item
      })

      return _.orderBy(mods, ['lastName'], ['asc'])
    },
  },

  watch: {
    currentView(newData) {
      this.getPayrollModifiersInRange(
        moment(newData.start + ' ' + this.siteconfig.payroll.shiftStartTime, 'YYYY-MM-DD HH:mm:ss').toISOString(),
        moment(newData.end   + ' ' + this.siteconfig.payroll.shiftStartTime, 'YYYY-MM-DD HH:mm:ss').toISOString()
      )
    },
  },

  methods: {
    // ─── Shared helper ───────────────────────────────────────────────────────
    buildFlsaSummaryRows(user) {
      const total = shifts =>
        shifts.reduce((sum, s) => sum + Number.parseFloat(s.payrollModHours || 0), 0)
    
      return [
        { bucket: 'FLSA',     shifts: user.flsa,    hours: total(user.flsa),    _showDetails: false },
        { bucket: 'Non-FLSA', shifts: user.nonFlsa,  hours: total(user.nonFlsa), _showDetails: false },
        { bucket: 'Other',    shifts: user.other,    hours: total(user.other),   _showDetails: false },
      ]
    },
    _buildDropdownItems(array) {
      const filter = array.filter(p => moment(p.start).format('YYYY') == this.currentYear)
      return _.orderBy(filter, ['start'], ['desc'])
        .map(p => ({ value: { start: p.start, end: p.end }, text: p.start + ' till ' + p.end }))
    },

    // ─── UI actions ──────────────────────────────────────────────────────────
    runRangeDate() {
      this.currentView = { start: this.selectStart, end: this.selectEnd }
    },

    selectAllEventMods(boo, data) {
      this.selectedFilter = boo ? data : []
    },

    refreshExportReports(id) {
      this.removeReport(id)
      this.getPreviousPayrollExports()
    },

    removeReport(id) {
      const index = this.viewReports.map(p => p.id).indexOf(id)
      this.viewReports.splice(index, 1)
    },

    getDateTime(data) {
      return data ? moment(data).format('MM/DD/YYYY HH:mm:ss') : 'Null Date'
    },

    // ─── Period navigation ────────────────────────────────────────────────────
    getCurrentPayPeriod() {
      const payroll       = this.siteconfig.payroll
      const today         = moment().format('YYYY-MM-DD')
      const presetVarDate = moment(payroll.payrollCycleDate, 'YYYY-MM-DD')

      if (this.cycleType == 'Pay Period') {
        if (payroll.payCycleType == 'biweekly') {
          const dateDiffCal = moment(today).diff(presetVarDate, 'days')
          const end         = Math.floor(dateDiffCal / 14)
          const endDate     = moment(presetVarDate).add(end * 2, 'weeks').format('YYYY-MM-DD')
          const startDate   = moment(endDate, 'YYYY-MM-DD').subtract(14, 'days').format('YYYY-MM-DD')
          this.currentView  = { start: startDate, end: endDate }
        } else if (payroll.payCycleType == 'weekly') {
          const dateDiffCal = moment(today, 'YYYY-MM-DD').diff(presetVarDate, 'days')
          const end         = Math.floor(dateDiffCal / 7)
          const endDate     = moment(presetVarDate).add(end, 'weeks').format('YYYY-MM-DD')
          const startDate   = moment(endDate, 'YYYY-MM-DD').subtract(7, 'days').format('YYYY-MM-DD')
          this.currentView  = { start: startDate, end: endDate }
        }
      } else if (this.cycleType == 'Work Week') {
        const dateDiffCal = moment(today).diff(presetVarDate, 'days')
        const end         = Math.floor(dateDiffCal / 7)
        const endDate     = moment(presetVarDate).add(end, 'weeks').format('YYYY-MM-DD')
        const startDate   = moment(endDate, 'YYYY-MM-DD').subtract(7, 'days').format('YYYY-MM-DD')
        this.currentView  = { start: startDate, end: endDate }
        
      } else if (this.cycleType == 'Kelly Cycle') {
        const preset      = moment(payroll.kellyCycleDate, 'YYYY-MM-DD').subtract(1, 'day')
        const dateDiffCal = moment(today).diff(preset, 'days')
        const end         = Math.floor(dateDiffCal / payroll.keyllyCycle)
        let   endDate     = moment(preset).add(end * payroll.keyllyCycle, 'days').format('YYYY-MM-DD')
        const startDate   = moment(endDate, 'YYYY-MM-DD').subtract(payroll.keyllyCycle - 1, 'days').format('YYYY-MM-DD')
        endDate           = moment(endDate, 'YYYY-MM-DD').add(1, 'days').format('YYYY-MM-DD')
        this.currentView  = { start: startDate, end: endDate }
      } else {
        const preset      = moment(payroll.cycleStartDate, 'YYYY-MM-DD').subtract(1, 'day')
        const dateDiffCal = moment(today).diff(preset, 'days')
        const end         = Math.floor(dateDiffCal / payroll.cycle)
        let   endDate     = moment(preset).add(end * payroll.cycle + payroll.cycle, 'days').format('YYYY-MM-DD')
        const startDate   = moment(endDate, 'YYYY-MM-DD').subtract(payroll.cycle - 1, 'days').format('YYYY-MM-DD')
        if (payroll.workCycleMainExport || this.siteconfig.deptUrlSub == 'gfr') {
          endDate = moment(endDate, 'YYYY-MM-DD').add(1, 'days').format('YYYY-MM-DD')
        }
        this.currentView = { start: startDate, end: endDate }
      }
    },

    // ─── Shift building ───────────────────────────────────────────────────────
    userProfileBuildShifts(data) {
      const events = []
      for (const i in data) {
        if (data[i].scheduledShift != 'Daily') {
          const indexColor = this.siteconfig.payroll.shifts.map(p => p.shift).indexOf(data[i].scheduledShift)
          const holdcolor  = indexColor != -1 ? this.siteconfig.payroll.shifts[indexColor].bootstrap : 'default'

          const startDate     = moment(data[i].rosterAssignmentStart).isBefore(this.currentView.start)
            ? this.currentView.start
            : moment(data[i].rosterAssignmentStart).format('YYYY-MM-DD')
          let shiftStartDate  = this.findFirstAvailableShifts(startDate, data[i].scheduledShift, data[i].userId)
          if (shiftStartDate.isBefore(data[i].scheduledShift)) {
            shiftStartDate = shiftStartDate.add(this.siteconfig.payroll.shiftRotation, 'd')
          }
          const endDate    = data[i].rosterAssignmentEnd && moment(data[i].rosterAssignmentEnd).isBefore(this.currentView.end)
            ? data[i].rosterAssignmentEnd
            : this.currentView.end
          const lengthCalc = moment(endDate).diff(shiftStartDate, 'days')
          let   length     = Math.floor(lengthCalc / this.siteconfig.payroll.shiftRotation)
          if (length == 0) length = 1

          for (let x = 0; x < length; x++) {
            const adv        = x * this.siteconfig.payroll.shiftRotation
            const date       = moment(shiftStartDate).add(adv, 'd').format('YYYY-MM-DD')
            const startTime  = moment(date + 'T' + data[i].rosterStartTime).toISOString()
            const endTime    = moment(startTime).add(data[i].rosterShiftLength, 'hours').toISOString()
            let   payrollCode = this.payrollCodesData.find(p => p.payrollCodeName == 'Regular Duty')
            let   kellyDay    = false

            if (this.kellyDayObject) {
              const kellyFilter = this.kellyDayObject.find(p =>
                moment(p.date).isSame(moment(date), 'day') &&
                p.shift == data[i].scheduledShift &&
                p.kelly == data[i].scheduledKellyCycleNumber
              )
              if (kellyFilter) {
                kellyDay    = true
                payrollCode = this.payrollCodesData.find(p => p.payrollCode == 'KD')
              }
            }

            if (payrollCode.payrollCodeExport == '*' && data[i].userId) {
              payrollCode = customJs.custom_export_gfr(
                this.fullDeptContactData.find(p => p.id == data[i].userId),
                _.cloneDeep(payrollCode)
              )
            }

            const obj = {
              color:               'text-' + holdcolor,
              payrollModType:      kellyDay ? 'Kelly Day' : 'normal',
              payrollModCode:      payrollCode?.payrollCode      || 'No Export',
              payrollModExport:    payrollCode?.payrollCodeExport || 'No Export',
              payrollModDatetime:  startTime,
              endTime,
              payrollModHours:     data[i].rosterShiftLength,
            }
            if (moment(startTime).isSameOrBefore(this.currentView.end)) {
              events.push(obj)
            }

            // Handle a partial trailing shift if the gap to endDate is >= one rotation
            if (x == length - 1) {
              const holdCheck = moment(endDate, 'YYYY-MM-DD').diff(moment(endTime).format('YYYY-MM-DD'), 'days')
              if (holdCheck >= this.siteconfig.payroll.shiftRotation) {
                const advNext      = (x + 1) * this.siteconfig.payroll.shiftRotation
                const dateNext     = moment(shiftStartDate).add(advNext, 'd').format('YYYY-MM-DD')
                const startTimeN   = moment(dateNext + 'T' + data[i].rosterStartTime).toISOString()
                const endTimeN     = moment(startTimeN).add(data[i].rosterShiftLength, 'hours').toISOString()
                let   pcNext       = this.payrollCodesData.find(p => p.payrollCodeName == 'Regular Duty')
                let   kellyDayNext = false

                if (pcNext.payrollCodeExport == '*' && data[i].userId) {
                  pcNext = customJs.custom_export_gfr(
                    this.fullDeptContactData.find(p => p.id == data[i].userId),
                    _.cloneDeep(pcNext)
                  )
                }
                if (this.kellyDayObject) {
                  const kf = this.kellyDayObject.find(p =>
                    moment(p.date).isSame(moment(dateNext), 'day') &&
                    p.shift == data[i].scheduledShift &&
                    p.kelly == data[i].scheduledKellyCycleNumber
                  )
                  if (kf) {
                    kellyDayNext = true
                    pcNext       = this.payrollCodesData.find(p => p.payrollCode == 'KD')
                  }
                }

                const newobj = {
                  color:              'text-' + holdcolor,
                  payrollModType:     kellyDayNext ? 'Kelly Day' : 'normal',
                  payrollModCode:     pcNext?.payrollCode      || 'No Export',
                  payrollModExport:   pcNext?.payrollCodeExport || 'No Export',
                  payrollModDatetime: startTimeN,
                  endTime:            endTimeN,
                  payrollModHours:    data[i].rosterShiftLength,
                }
                if (moment(startTimeN).isSameOrBefore(this.currentView.end)) {
                  events.push(newobj)
                }
              }
            }
          }
        } else {
          // Daily shift
          const indexColor = this.siteconfig.payroll.shifts.map(p => p.shift).indexOf(data[i].scheduledShift)
          const holdcolor  = indexColor != -1 ? this.siteconfig.payroll.shifts[indexColor].bootstrap : 'default'

          const startDate = moment(data[i].rosterAssignmentStart).isBefore(this.currentView.start)
            ? this.currentView.start
            : moment(data[i].rosterAssignmentStart).format('YYYY-MM-DD')
          const endDate   = data[i].rosterAssignmentEnd && moment(data[i].rosterAssignmentEnd).isBefore(this.currentView.end)
            ? data[i].rosterAssignmentEnd
            : this.currentView.end
          const days   = data[i].scheduledWorkDays
          const length = moment(endDate, 'YYYY-MM-DD').diff(startDate, 'days')

          for (let x = 0; x < length; x++) {
            const date      = moment(startDate).add(x, 'd').format('YYYY-MM-DD')
            const testDay   = days.indexOf(moment(date, 'YYYY-MM-DD').format('ddd'))
            if (testDay == -1) continue

            const startTime  = moment(date + 'T' + data[i].rosterStartTime).toISOString()
            const endTime    = moment(startTime).add(data[i].rosterShiftLength, 'hours').toISOString()
            let   payrollCode = this.payrollCodesData.find(p => p.payrollCodeName == 'Regular Duty')
            if (payrollCode.payrollCodeExport == '*' && data[i].userId) {
              payrollCode = customJs.custom_export_gfr(
                this.fullDeptContactData.find(p => p.id == data[i].userId),
                _.cloneDeep(payrollCode),
                true
              )
            }
            events.push({
              color:              'text-' + holdcolor,
              payrollModType:     'normal',
              payrollModCode:     payrollCode?.payrollCode      || 'No Export',
              payrollModExport:   payrollCode?.payrollCodeExport || 'No Export',
              payrollModDatetime: startTime,
              endTime,
              payrollModHours:    data[i].rosterShiftLength,
              daily:              true,
            })
          }
        }
      }
      return events
    },

    findFirstAvailableShifts(date, profileshift, id) {
      const payroll        = this.siteconfig.payroll
      const indexOfDate    = payroll.shifts.map(p => p.shift).indexOf(profileshift)
      const selectedVarDate = moment(date, 'YYYY-MM-DD')
      const presetVarDate  = moment(payroll.payrollCycleDate, 'YYYY-MM-DD')
      const dateDiffCal    = selectedVarDate.diff(presetVarDate, 'days')
      const dateDiffCalNum = 100 * (dateDiffCal / payroll.shiftRotation)
      let roundedDated

      if (payroll.shiftRotation == 4) {
        roundedDated = (dateDiffCalNum % 100) / 25
      } else {
        const dateTenDigit = dateDiffCalNum % 10
        roundedDated       = Math.floor(dateTenDigit / payroll.shiftRotation)
      }

      const advance  = indexOfDate - roundedDated
      let testDate   = selectedVarDate.add(advance, 'd')
      if (testDate.isBefore(date)) {
        testDate = testDate.add(payroll.shiftRotation, 'd')
      }
      return testDate
    },

    // ─── Payroll mods ─────────────────────────────────────────────────────────
    sortModifications(reg, mods, user, employeeId) {
      const array = reg
      const modsA = []
      const adj   = []

      for (const i in mods) {
        const obj         = _.cloneDeep(mods[i])
        obj['payrollModCodeDb'] = mods[i].payrollModCode
        let payrollMod    = this.payrollCodesData.find(p => p.id == mods[i].payrollModCode)
        const exchange    = mods[i].payrollModExchangeUserId == user
        let exOn          = ''

        if (payrollMod?.payrollCodeCategory == 'overtime availability') {
          const code  = payrollMod.payrollCode
          const index = this.selectedFilter.indexOf(code)
          if (index < 0) this.selectedFilter.push(code)
        }
        if (exchange) {
          payrollMod = this.payrollCodesData.find(p => p.payrollCode == 'EXON')
        }
        if (mods[i].payrollModType == 'exchange' && mods[i].payrollModExchangeUserId != user) {
          payrollMod = this.payrollCodesData.find(p => p.payrollCode == 'EXOFF')
        }

        obj['startTime']        = mods[i].payrollModDatetime
        obj['endTime']          = moment(mods[i].payrollModDatetime).add(mods[i].payrollModHours, 'hours').toISOString()
        obj['payrollModExport'] = payrollMod?.payrollCodeExport || exOn?.payrollCodeExport || 'No Export'
        obj['payrollModCode']   = payrollMod?.payrollCode       || exOn?.payrollCode       || 'No Code'

        if (this.createVacancy.indexOf(mods[i].payrollModType) != -1 || obj.payrollModCode == 'EXOFF') {
          adj.push(obj)
        } else {
          modsA.push(obj)
        }
      }

      const fixed = this.checkForUserMods(array, adj)
      for (const m in modsA) fixed.push(modsA[m])

      if (this.kellyDayObject) {
        const kellyDays = array.filter(p => p.payrollModExport == 'KD')
        for (const k in kellyDays) {
          const index = fixed
            .filter(p => p.payrollModExport == 'KD')
            .map(p => p.payrollModDatetime)
            .indexOf(kellyDays[k].payrollModDatetime)
          if (index < 0) fixed.push(kellyDays[k])
        }
      }

      return _.orderBy(fixed, ['payrollModDatetime'], ['asc'])
    },

    getFixedSwap(array, mods) {
      function doTheLoop() {
        for (let a = 0; a < array.length; a++) {
          const mod = mods.filter(p =>
            moment(p.payrollModDatetime).isSameOrAfter(array[a].payrollModDatetime) &&
            moment(p.endTime).isSameOrBefore(array[a].endTime)
          )
          if (mod) {
            for (const m in mod) {
              const sameStart = moment(mod[m].payrollModDatetime).isSame(array[a].payrollModDatetime)
              const sameEnd   = moment(mod[m].endTime).isSame(array[a].endTime)
              const afterStart = moment(mod[m].payrollModDatetime).isAfter(array[a].payrollModDatetime)
              const beforeEnd  = moment(mod[m].endTime).isBefore(array[a].endTime)

              // Exact match — remove the shift
              if (sameStart && sameEnd) {
                array.splice(a, 1)
                return true
              }
              // Mod starts after shift start, same end — trim right
              if (afterStart && sameEnd) {
                const obj = _.cloneDeep(array[a])
                obj.payrollModDatetime  = array[a].payrollModDatetime
                obj.endTime             = mod[m].payrollModDatetime
                obj.payrollModHours     = moment(obj.endTime).diff(obj.payrollModDatetime, 'hours', true)
                array[a] = obj
              }
              // Same start, mod ends before shift end — trim left
              if (sameStart && beforeEnd) {
                const obj = _.cloneDeep(array[a])
                obj.payrollModDatetime  = mod[m].endTime
                obj.endTime             = array[a].endTime
                obj.payrollModHours     = moment(obj.endTime).diff(obj.payrollModDatetime, 'hours', true)
                array[a] = obj
              }
              // Mod is interior — split into two
              if (afterStart && beforeEnd) {
                const obj    = _.cloneDeep(array[a])
                const objTwo = _.cloneDeep(array[a])
                obj.payrollModDatetime    = array[a].payrollModDatetime
                obj.endTime               = mod[m].payrollModDatetime
                obj.payrollModHours       = moment(obj.endTime).diff(obj.payrollModDatetime, 'hours', true)
                objTwo.payrollModDatetime = mod[m].endTime
                objTwo.endTime            = array[a].endTime
                objTwo.payrollModHours    = moment(objTwo.endTime).diff(objTwo.payrollModDatetime, 'hours', true)
                array.push(objTwo)
                array[a] = obj
              }
              return true
            }
          }
        }
        return false
      }
      while (doTheLoop()) {}
      return array
    },

    checkForUserMods(dates, adjust) {
      const array   = []
      const allMods = _.cloneDeep(adjust)
      for (const u in dates) {
        const mods = _.orderBy(
          adjust.filter(p =>
            moment(p.payrollModDatetime).isBefore(dates[u].endTime) &&
            moment(dates[u].payrollModDatetime).isBefore(p.endTime)
          ),
          ['payrollModDatetime'], ['asc']
        )
        if (mods.length > 0) {
          const basesplit = this.getFixedSwap([_.cloneDeep(dates[u])], mods)
          for (const b in basesplit) array.push(basesplit[b])
        } else {
          array.push(dates[u])
        }
      }
      for (const i in allMods) array.push(allMods[i])
      return array
    },

    // ─── Report / export actions ──────────────────────────────────────────────
    generateNewReport(data) {
      const report = {
        title:              this.cycleType + ' ' + this.currentView.start + ' till ' + this.currentView.end,
        exportAuthor:       this.userData.firstName + ' ' + this.userData.lastName,
        exportAuthorId:     this.userData.id,
        requestVerification: false,
        payrollData:        data.map(item => ({ userid: item.id, shifts: item.shifts, verification: false })),
        newReport:          true,
      }
      this.viewReports.push(report)
    },

    downloadAsCsvFull() {
      const fileExtension = this.siteconfig.payroll.customExportFileType || '.csv'
      const title  = this.cycleType + ' Custom Export ' + this.currentView.start + ' till ' + this.currentView.end + fileExtension
      const header = !!this.siteconfig.payroll.customExportHeader
      const data   = Papa.unparse(this.fixDataExcel, { header })
      const blob   = new Blob([data], { type: 'text/csv' })
      const link   = document.createElement('a')
      link.href = window.URL.createObjectURL(blob)
      link.setAttribute('download', title)
      link.click()
    },

    downloadAsCsv() {
      const fileExtension = this.siteconfig.payroll.customExportFileType || '.csv'
      const title  = this.cycleType + ' Custom Export ' + this.currentView.start + ' till ' + this.currentView.end + fileExtension
      const header = !!this.siteconfig.payroll.customExportHeader
      const data   = Papa.unparse(this.fixDataExcelCustom, { header })
      const blob   = new Blob([data], { type: 'text/csv' })
      const link   = document.createElement('a')
      link.href = window.URL.createObjectURL(blob)
      link.setAttribute('download', title)
      link.click()
    },

    // ─── API calls ────────────────────────────────────────────────────────────
    getPreviousPayrollExports() {
      axios({
        method: 'get',
        url: '/api/v1/staffing/payrollexport/short',
        headers: { 'Authorization': this.getSessionData, 'Content-Type': 'application/json' },
      }).then(response => {
        this.payrollReports = _.orderBy(response.data, ['createdAt'], ['desc'])
      })
    },

    getPayrollModifiersInRange(start, end) {
      this.disableGenerateReport = true
      axios({
        method: 'get',
        url: '/api/v1/staffing/payrollmod/daily/' + start + '/' + end,
        headers: { 'Authorization': this.getSessionData, 'Content-Type': 'application/json' },
      }).then(response => {
        if (response.data) {
          this.payrollRecoMods = response.data.filter(p =>
            p.payrollModDatetime &&
            p.payrollModHours > 0 &&
            p.payrollModHours != null &&
            p.payrollModType != 'roster mod' &&
            moment(p.payrollModDatetime).isBefore(end)
          )
          this.$nextTick(() => { this.disableGenerateReport = false })
        }
      })
    },

    viewPreviousReportData(id) {
      axios({
        method: 'get',
        url: '/api/v1/staffing/payrollexport/' + id,
        headers: { 'Authorization': this.getSessionData, 'Content-Type': 'application/json' },
      }).then(response => {
        if (response.data && response.data[0]) {
          this.viewReports.push(response.data[0])
        }
      })
    },
  },
}
</script>

<style>
.table th {
  text-align: center !important;
}
</style>

<style scoped>
.payroll-black        { background-color: #000;    color: white; padding: 4px 5px 2px; border-radius: 5px; }
.payroll-bright-blue  { background-color: #007bff; color: white; padding: 4px 5px 2px; border-radius: 5px; }
.payroll-blue         { background-color: #00438b; color: white; padding: 4px 5px 2px; border-radius: 5px; }
.payroll-Yellow       { background-color: #ffeb4f; color: black; padding: 4px 5px 2px; border-radius: 5px; }
.payroll-default      { background-color: #e3e3e3; color: black; padding: 4px 5px 2px; border-radius: 5px; }
.payroll-bright-orange{ background-color: #ffb039; color: black; padding: 4px 5px 2px; border-radius: 5px; }
.payroll-orange       { background-color: #ff7400; color: black; padding: 4px 5px 2px; border-radius: 5px; }
.payroll-bright-purple{ background-color: #ab4fff; color: white; padding: 4px 5px 2px; border-radius: 5px; }
.payroll-purple       { background-color: #51009b; color: white; padding: 4px 5px 2px; border-radius: 5px; }
.payroll-bright-green { background-color: #0fb906; color: white; padding: 4px 5px 2px; border-radius: 5px; }
.payroll-green        { background-color: #0a7622; color: white; padding: 4px 5px 2px; border-radius: 5px; }
.payroll-bright-red   { background-color: #ff0000; color: white; padding: 4px 5px 2px; border-radius: 5px; }
.payroll-red          { background-color: #b40000; color: white; padding: 4px 5px 2px; border-radius: 5px; }

.collapsed > .when-opened,
:not(.collapsed) > .when-closed {
  display: none;
}
.bootstrapMobile { display: none; }
.inlineBlock     { display: inline-block; }
h1, h2           { font-weight: normal; }

@media screen and (max-width: 768px) {
  .bootstrapTable  { display: none; }
  .bootstrapMobile { display: block; }
}
</style>
